import { render, staticRenderFns } from "./BankBrokersModal.vue?vue&type=template&id=3924165c&scoped=true"
import script from "./BankBrokersModal.vue?vue&type=script&lang=js"
export * from "./BankBrokersModal.vue?vue&type=script&lang=js"
import style0 from "./BankBrokersModal.vue?vue&type=style&index=0&id=3924165c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924165c",
  null
  
)

export default component.exports